export default __webpack_public_path__ + "static/media/lading-banner.fe366807.jpg";